import React, { lazy } from 'react';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Search = lazy(() => import(`globalcomponents/UI/SimpleSearch/${layout}`));

const TopActions = ({ filterSuccess, Styled, i18n, notInUseVehicles, setPagination }) => {
  const selectChange = (e) => {
    filterSuccess(e);
    setPagination(true);
  };
  return (
    <Styled.TopWrapper>
      <Styled.SearchWrapper>
        <Search
          id="out_of_service"
          onChange={(e) => selectChange(e)}
          default={notInUseVehicles?.notInUseVehicles}
          fromData
          placeHolder={i18n.t('vehicles.searchVehicle')}
          query={['unit_id', 'drivers', 'type', 'vin', 'year', 'manufact', 'model']}
        />
      </Styled.SearchWrapper>
    </Styled.TopWrapper>
  );
};
export default TopActions;
